import { Skeleton } from 'src/components/Skeleton';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

export default function CartSummaryRow({
  label,
  value,
  isLoading,
}: {
  label: string;
  value: string;
  isLoading: boolean;
}) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      {isLoading ? (
        <Skeleton variant="text" width={56} height={18} />
      ) : (
        <Typography variant="h6">{value}</Typography>
      )}
    </Stack>
  );
}
